import { Box, Container } from '@material-ui/core';

import Hidden from './HiddenSSRCompatible';
import { Loading } from '@microrealestate/commonui/components';

function PageContent({ maxWidth, children, marginXMobile, isStandalonePage = false }) {
  return (
    <>
      <Hidden smDown>
        <Box ml={isStandalonePage ? 0 : 7}>
          <Container maxWidth={maxWidth}>
            <Box my={isStandalonePage ? 0 : 2}>{children}</Box>
          </Container>
        </Box>
      </Hidden>
      <Hidden mdUp>
        <Box mb={isStandalonePage ? 0 : 10} mx={marginXMobile}>
          {children}
        </Box>
      </Hidden>
    </>
  );
}

function Page({ children, ActionBar, marginMobile = 2 , maxWidth = 'lg', loading = false, isStandalonePage = false }) {
  return (
    <PageContent maxWidth={maxWidth} marginXMobile={marginMobile} isStandalonePage={isStandalonePage}>
      {marginMobile !== 2 ? (
        <></>
      ) : (
        <Box mb={2}>{ActionBar}</Box>
      )}
      {loading ? <Loading fullScreen /> : children}
    </PageContent>
  );
}

export default Page;
